import PropTypes from "prop-types";
import AgentCallsRow from "./AgentCallsRow";
import AgentCallsTotalRow from "./AgentcallsTotalRow";

const AgentCallsHolder = ({ agentCallData }) => (
  <>
    {agentCallData.callData.map((a) => (
      <AgentCallsRow key={a.id} agent={a} />
    ))}

    {agentCallData.callData.length > 1 && <AgentCallsTotalRow reportData={agentCallData.callData} />}
  </>
);

AgentCallsHolder.propTypes = {
  agentCallData: PropTypes.shape({
    callData: PropTypes.arrayOf(PropTypes.shape()),
  }).isRequired,
};

export default AgentCallsHolder;
